import { brand } from '../../../theme/themePrimitives';
import CustomModal from '../../modals';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';
import { Box, Button, Typography } from '@mui/material';

const DuplicateCalendarLinkModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const { selectedEvent } = useSelector((state: RootState) => state.calendar);
    const duplicateCalendarLinkHandler = () => {
        try {
            // await dispatch(deletePipelineThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            // Close the modal after successful deletion
            onClose();
        } catch (e) {
            // Catch Errors
        }
    };

    return <CustomModal open={open} handleClose={onClose} title="Duplicate Calendar Link">
        {/* Warning message with Calendar link name */}
        <Typography variant="body1" align="center" mb={2}>Are you sure you want to duplicate this Calendar link with name &quot;<Typography component="span" variant="body1" color={brand[300]}>{selectedEvent?.event_name}</Typography>&quot;?</Typography>
        <Typography variant="body2" align="center" color="textSecondary">(All the settings in the calendar link will be repeated)</Typography>
        {/* Action buttons */}
        <Box display="flex" gap={2} mt={2}>
            <Button variant="outlined" color="secondary" onClick={onClose} fullWidth>
                Cancel
            </Button>
            <Button type="submit" variant="contained" onClick={duplicateCalendarLinkHandler} fullWidth>
                Confirm
            </Button>
        </Box>
    </CustomModal>;
};

export default DuplicateCalendarLinkModal;